<template>
  <div class="login" :class="notSignedInMap ? 'not-signed-in-map' : ''" ref="notSignedIn" @focusout="handleFocusOut"
    tabindex="0">
    <div class="container">
      <div class="d-flex flex-row justify-content-center">
        <div class="box">
          <div class="not-signed-in">You need to be signed in to use favorites.</div>
          <b-button ref="signInModal" v-b-modal="objectid" @mousedown="openSignInView" class="login-btn">
            <span class="login-text">Sign In</span>
          </b-button>
          <div @mousedown="cancel" class="cancel">Cancel</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'overlay-not-signed-in',
  props: {
    objectid: {
      type: String,
    },
    notSignedInMap: {
      type: Boolean,
    },
  },
  data() {
    return {
      isSignUp: false,
    };
  },
  mounted() {
    this.$refs.notSignedIn.focus();
  },
  methods: {
    handleFocusOut() {
      if (this.isSignUp) {
        setTimeout(() => {
          this.$root.$emit('hideONSI', false);
        }, 250);
        return;
      }
      this.$root.$emit('hideONSI', false);
    },
    openSignInView() {
      this.isSignUp = true;
      this.$root.$emit('showSIinUserFavorite');
      this.$root.$emit('toggleCarouselInterval', 0);
    },
    cancel() {
      this.$root.$emit('hideONSI', false);
    },
  },
};
</script>

<style>
/* Override bootstrap modal backdrop and content classes */
div>div.modal {
  background-color: #fff;
  opacity: 0.98;
}

div>div.modal .modal-content {
  border: none;
}
</style>

<style scoped>
.box {
  background: #fff;
  border: 1px solid #eaeaea;
  border-radius: 3px;
  padding-top: 35px;
  text-align: left;
  width: 250px;
}

.box:hover {
  cursor: default;
}

.not-signed-in {
  color: #173945;
  font-family: 'klinicslabmedium';
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 900;
  height: 63px;
  letter-spacing: 0.83px;
  line-height: normal;
  margin: 0 auto;
  margin-bottom: 20px;
  text-align: center;
  width: 153px;
}

.login-btn {
  background-color: #173945;
  border: solid 1px #979797;
  border-radius: 8px;
  cursor: pointer;
  height: 36px;
  margin-left: 45px;
  text-align: center;
  width: 155px;
}

.login-text {
  color: #f7f6f1;
  height: 18px;
  font-family: 'IdealSans-Medium';
  font-size: 18px;
  font-stretch: normal;
  font-style: normal;
  font-weight: 500;
  letter-spacing: 0.5px;
  line-height: normal;
  text-align: center;
  width: 69px;
}

.login-btn:focus {
  outline: 2.75px dotted !important;
  outline-color: #4c8ea0 !important;
  outline-offset: 3px !important;
}

.login-btn:hover {
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.cancel {
  color: #000;
  display: flex;
  height: 12px;
  margin-top: 15px;
  margin-bottom: 50px;
  font-family: 'IdealSans-Book';
  font-size: 12px;
  font-stretch: normal;
  font-style: normal;
  font-weight: normal;
  justify-content: center;
  letter-spacing: 0.39px;
  line-height: normal;
}

.login {
  left: -200px !important;
  margin-top: 5px;
  position: absolute;
  z-index: 999;
}

.not-signed-in-map {
  left: 5px !important;
}

button,
.cancel {
  cursor: pointer;
}

.btn-sign-in {
  margin: 0px 5px 10px 0px;
  padding: 15px 35px 10px 35px;
}</style>
